<template>
  <basic-container>
    <!-- main banner -->
    <div class="blog-container">
      <div class="banner_w3lspvt-2">
        <ol class="breadcrumb">
          <li class="breadcrumb-item" aria-current="page">{{ $t('blog.title') }}</li>
        </ol>
      </div>
      <div class="container1500">
        <div id="cn">
          <div class="page-wrapper">
            <div class="container">
              <div class="row">
                <div class="col-md-8 col-12" v-loading="isLoading">
                  <div class="data-list">
                    <div v-for="(item, index) in allDataList" :key="index" class="post">
                      <div class="post-meta">
                        <ul>
                          <li>
                            <i class="el-icon-date"></i> {{ item.createDate }}
                          </li>
                          <li>
                            <i class="el-icon-s-custom"></i> Posted by 箭弩学术
                          </li>
                          <li>
                            <a href="#"><i class="el-icon-price-tag"></i>
                              {{ item.fieldC }}</a>
                          </li>
                        </ul>
                      </div>
                      <div class="post-content" style="text-align: justify">
                        <p class="two">
                          {{ item.fieldA }}
                        </p>
                        <p class="three">{{ item.fieldB }}</p>
                        <a @click="pushDetail(item.id)" class="btn btn-main">{{$t('blog.readAll')}}</a>
                      </div>
                    </div>
                    <!-- 分页 -->
                    <el-pagination v-if="total>10" small layout="prev, pager, next" :current-page.sync="page" :page-size="pageSize"
                      :total="total" @current-change="updateCurrentPageData" :prev-text="$t('paginationText.prevText')" :next-text="$t('paginationText.nextText')"></el-pagination>
                     
                  </div>
                  <div class="text-center">
                    <div id="demo20"></div>
                  </div>
                </div>
                <div class="col-md-4" >
                  <aside class="sidebar">
                    <div class="widget widget-tag">
                      <h4 class="widget-title">{{$t('blog.keyWord')}}</h4>
                      <ul class="widget-tag-list" v-loading="rightLoading">
                        <li class="biaoqianClick" :class="{ active: selectedTag === 'All' }" @click="selectTag('All')">
                          <a href="javascript:void(0)">All</a>
                        </li>
                        <li v-for="(tag, index) in tags" :key="index" class="biaoqianClick"
                          :class="{ active: selectedTag === tag.fieldC }" @click="selectTag(tag)">
                          <a href="javascript:void(0)">{{ tag.fieldC }}</a>
                        </li>
                      </ul>
                    </div>
                  </aside>
                </div>
              </div>
            </div>

          </div>
        </div>


      </div>
    </div>
  </basic-container>
</template>

<script>
// 引入样式
import "@/assets/originCss/blog.css";
import { getBlogList, getNewsList } from "@/api/blog/blog";

export default {
  name: "Blog",
  data() {
    return {
      allDataList: [], // 存储所有已加载的数据
      dataList: [],     // 当前页显示的数据
      tags: [],
      page: 1,
      pageSize: 10,
      total: null,
      selectedTag: null,
      isLoading: false,
      rightLoading:false
    };
  },
  created() {},
  mounted() {
    this.getBiaoqian();
    this.getDataList();
  },
  methods: {
    // 获取新闻列表
    getDataList() {
      if (this.selectedTag === "All") {
        this.selectedTag = null;
      }
      const paramMap = {
        page: this.page,
        pageSize:this.pageSize, 
        biaoqian: this.selectedTag,
        classification: "jiannu",
      };
      this.isLoading = true;
      getNewsList(paramMap).then((response) => {       
        this.allDataList = response.data.records;
        this.total = response.data.total || 0;
        this.isLoading = false;
      }).catch(error => {
        this.$message.error(error.message);
      });
    },

    updateCurrentPageData(val) {
      this.page = val
      this.getDataList()
    },

    // 获取标签
    getBiaoqian() {
      this.rightLoading = true;
      getBlogList().then((res) => {
        this.tags = res.data.map((tag) => ({
          ...tag,
          active: false,
        }));
        this.rightLoading = false;
      });
    },

    // 选择标签，请求数据
    selectTag(tag) {
      this.selectedTag = typeof tag === "string" ? tag : tag.fieldC;
      this.page = 1; // 重置页码
      this.allDataList = []; // 清空已加载的数据
      this.getDataList();
    },

    //跳详情页

    pushDetail(id){
      this.$router.push({
        path: '/blogDetail',
        query: {
          id: id
        }
      })
    }

  
  },
};
</script>

<style lang="scss" scoped>
.el-pagination {
  text-align: center;
}

.two{
  color:#333;
  font-size: 20px;
  word-break: break-all;
}


</style>